import basicdata from '@manage/api/api.basicdata'
export default [
  {
    type: 'input',
    placeholder: '设备SN码',
    filed: 'assetNumber',
    default: ''
  },
  {
    type: 'input',
    placeholder: '设备IMEI',
    filed: 'imei',
    default: ''
  },
  {
    type: 'cascader',
    placeholder: '设备类型型号',
    filed: 'typeNumber',
    default: [],
    query: basicdata.device_model_cascade + '?devType=01'
  },
  {
    type: 'select',
    placeholder: '大客户',
    filed: 'customerId',
    default: '',
    query: basicdata.customer_select + '?accountLevel=kalifon'
  },
  {
    type: 'select',
    placeholder: 'APP参数修改状态',
    filed: 'appChange',
    default: '',
    options: [
      {
        code: 0,
        name: '未修改'
      },
      {
        code: 1,
        name: '已修改'
      }
    ]
  },
  {
    type: 'select',
    placeholder: '在线状态',
    filed: 'online',
    default: '',
    options: [
      {
        code: 'offline',
        name: '离线'
      },
      {
        code: 'online',
        name: '在线'
      }
    ]
  }
]
